export const GET_HOTSPOT_DATA = "GET_HOTSPOT_DATA";
export const SET_HOTSPOT_DATA = "SET_HOTSPOT_DATA";
